<template>
  <div class="certificate-item flex">
    <template v-if="!disabled">
      <upload
        :props-data="{
          bizType: 'enterprise',
          attachmentType: 'bank_license',
          uploadMode: 'fileId',
          photoWall: true,
          photoWallStyle: {
            width: '140px',
            height: '140px'
          },
          watermark: 1,
          watermarkText: '精彩纵横云采购注册认证使用，不可用于其它使用，违者必究',
          fileIdBefore: fileId,
          fileSize: 5,
          onSuccess: fileId => $emit('change', fileId)
        }"
      />
      <div class="edit-desc">
        <p class="desc-title">{{ uploadTitle }}</p>
        <div class="desc-con">
          <slot name="uploadDesc">
            <p>{{ uploadDesc }}</p>
          </slot>
        </div>
        <el-button
          v-if="samplePictureUrl"
          type="text"
          @click="showSamplePicture"
        >查看示例图片</el-button>
        <download-file
          v-if="templateDownloadUrl"
          :download-link="templateDownloadUrl"
          class="m-l-20"
        >
          <span class="text-btn font-14">模板下载</span>
        </download-file>
      </div>
    </template>
    <template v-else>
      <preview-image
        :file-id="fileId"
        :need-preview="true"
        :need-wrapper="true"
        width="200px"
        height="120px"
      />
      <p class="not-edit-desc">
        {{ uploadTitle }}
      </p>
    </template>

    <!-- 弹出框，查看大图 -->
    <el-image-viewer
      v-if="samplePictureDialog"
      :on-close="() => (samplePictureDialog = false)"
      :url-list="[samplePictureUrl]"
    />
  </div>
</template>

<script>
// 组件
import Upload from '@/components/Upload'
import DownloadFile from '@/components/DownloadFile'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'CredentialItem',

  components: {
    Upload,
    ElImageViewer,
    DownloadFile
  },

  model: {
    prop: 'fileId',
    event: 'change'
  },

  props: {
    fileId: {
      type: [String, Number],
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    uploadTitle: {
      type: String,
      default: ''
    },

    uploadDesc: {
      type: String,
      default: ''
    },

    samplePictureUrl: {
      type: String,
      default: ''
    },

    templateDownloadUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      // 弹窗展示示例图片
      samplePictureDialog: false
    }
  },

  methods: {
    // 查看示例图片
    showSamplePicture() {
      this.samplePictureDialog = true
    }
  }
}
</script>

<style scoped lang="scss">
// 企业证件列表项样式
.certificate-item {
  padding: 18px 20px;
  border-radius: 4px;
  background: $info-fifth-color;

  .not-edit-desc {
    margin-left: 9px;
  }

  .edit-desc {
    margin-left: 9px;

    .download-file {
      color: $primary-color;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        opacity: 0.6;
      }
    }

    .desc-title {
      margin: 0;
    }
    .desc-con {
      color: $text-third-color;
      font-size: 12px;
      height: 75px;
      margin-top: 5px;

      p {
        margin: 0;
        line-height: 2;
      }
    }
  }
}
</style>
